import { render, staticRenderFns } from "./select_locale.vue?vue&type=template&id=4a30f486&scoped=true&"
import script from "./select_locale.vue?vue&type=script&lang=js&"
export * from "./select_locale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a30f486",
  null
  
)

export default component.exports